/*jshint multistr: true */

// Keep order to preserve side-effect execution sequence.
import '../lib/lazysizes.min.js';
import './modules/analytics_events.js';
import './modules/navigation.js';
import './modules/dfp.js';
import './modules/user_profile.js';
import './modules/sticky.js'; // registers global stickyFill()
import './modules/share.js';
import './modules/load_more.js';
import './modules/form_submit.js';
import './modules/didomi.js';
// Stickyfill (needed by initSticky below and some modules); previously only referenced in sticky module via Prepros directive
// stickyfill is imported inside modules/sticky.js to preserve order & encapsulation

// global variable so it can be used in template files
// if input field value length is not 0
// it get's a is_filled class that styles the label of the field
window.checkInputLength = function ($input) {

    // modal inputs
    if ($input.is('input, textarea')) {

        if ($input.val().length === 0) {
            $input.removeClass('is_filled');
        } else {
            $input.addClass('is_filled');
        }

        // new comment field or reply comment field
    } else if ($input.is('div')) {

        if ($input.text().length === 0) {
            $input.removeClass('is_filled');
        } else {
            $input.addClass('is_filled');
        }
    }
};

$(function () {

    /*
     * classList.js: Cross-browser full element.classList implementation.
     * 2014-07-23
     *
     * By Eli Grey, http://eligrey.com
     * Public Domain.
     * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
     */

    /*global self, document, DOMException */

    /*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/

    if ('document' in self) {

        // Full polyfill for browsers with no classList support
        if (!('classList' in document.createElement('_'))) {

            (function (view) {

                'use strict';

                if (!('Element' in view)) return;

                var
                    classListProp = 'classList',
                    protoProp = 'prototype',
                    elemCtrProto = view.Element[protoProp],
                    objCtr = Object,
                    strTrim = String[protoProp].trim || function () {
                        return this.replace(/^\s+|\s+$/g, '');
                    },
                    arrIndexOf = Array[protoProp].indexOf || function (item) {
                        var
                            i = 0,
                            len = this.length;
                        for (; i < len; i++) {
                            if (i in this && this[i] === item) {
                                return i;
                            }
                        }
                        return -1;
                    },
                    // Vendors: please allow content code to instantiate DOMExceptions
                    DOMEx = function (type, message) {
                        this.name = type;
                        this.code = DOMException[type];
                        this.message = message;
                    },
                    checkTokenAndGetIndex = function (classList, token) {
                        if (token === '') {
                            throw new DOMEx(
                                'SYNTAX_ERR', 'An invalid or illegal string was specified'
                            );
                        }
                        if (/\s/.test(token)) {
                            throw new DOMEx(
                                'INVALID_CHARACTER_ERR', 'String contains an invalid character'
                            );
                        }
                        return arrIndexOf.call(classList, token);
                    },
                    ClassList = function (elem) {
                        var
                            trimmedClasses = strTrim.call(elem.getAttribute('class') || ''),
                            classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
                            i = 0,
                            len = classes.length;
                        for (; i < len; i++) {
                            this.push(classes[i]);
                        }
                        this._updateClassName = function () {
                            elem.setAttribute('class', this.toString());
                        };
                    },
                    classListProto = ClassList[protoProp] = [],
                    classListGetter = function () {
                        return new ClassList(this);
                    };
                // Most DOMException implementations don't allow calling DOMException's toString()
                // on non-DOMExceptions. Error's toString() is sufficient here.
                DOMEx[protoProp] = Error[protoProp];
                classListProto.item = function (i) {
                    return this[i] || null;
                };
                classListProto.contains = function (token) {
                    token += '';
                    return checkTokenAndGetIndex(this, token) !== -1;
                };
                classListProto.add = function () {
                    var
                        tokens = arguments,
                        i = 0,
                        l = tokens.length,
                        token, updated = false;
                    do {
                        token = tokens[i] + '';
                        if (checkTokenAndGetIndex(this, token) === -1) {
                            this.push(token);
                            updated = true;
                        }
                    }
                    while (++i < l);

                    if (updated) {
                        this._updateClassName();
                    }
                };
                classListProto.remove = function () {
                    var
                        tokens = arguments,
                        i = 0,
                        l = tokens.length,
                        token, updated = false,
                        index;
                    do {
                        token = tokens[i] + '';
                        index = checkTokenAndGetIndex(this, token);
                        while (index !== -1) {
                            this.splice(index, 1);
                            updated = true;
                            index = checkTokenAndGetIndex(this, token);
                        }
                    }
                    while (++i < l);

                    if (updated) {
                        this._updateClassName();
                    }
                };
                classListProto.toggle = function (token, force) {
                    token += '';

                    var
                        result = this.contains(token),
                        method = result ?
                            force !== true && 'remove' :
                            force !== false && 'add';

                    if (method) {
                        this[method](token);
                    }

                    if (force === true || force === false) {
                        return force;
                    } else {
                        return !result;
                    }
                };
                classListProto.toString = function () {
                    return this.join(' ');
                };

                if (objCtr.defineProperty) {
                    var classListPropDesc = {
                        get: classListGetter,
                        enumerable: true,
                        configurable: true
                    };
                    try {
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    } catch (ex) { // IE 8 doesn't support enumerable:true
                        if (ex.number === -0x7FF5EC54) {
                            classListPropDesc.enumerable = false;
                            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                        }
                    }
                } else if (objCtr[protoProp].__defineGetter__) {
                    elemCtrProto.__defineGetter__(classListProp, classListGetter);
                }

            }(self));

        } else {
            // There is full or partial native classList support, so just check if we need
            // to normalize the add/remove and toggle APIs.

            (function () {
                'use strict';

                var testElement = document.createElement('_');

                testElement.classList.add('c1', 'c2');

                // Polyfill for IE 10/11 and Firefox <26, where classList.add and
                // classList.remove exist but support only one argument at a time.
                if (!testElement.classList.contains('c2')) {
                    var createMethod = function (method) {
                        var original = DOMTokenList.prototype[method];

                        DOMTokenList.prototype[method] = function (token) {
                            var i, len = arguments.length;

                            for (i = 0; i < len; i++) {
                                token = arguments[i];
                                original.call(this, token);
                            }
                        };
                    };
                    createMethod('add');
                    createMethod('remove');
                }

                testElement.classList.toggle('c3', false);

                // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
                // support the second argument.
                if (testElement.classList.contains('c3')) {
                    var _toggle = DOMTokenList.prototype.toggle;

                    DOMTokenList.prototype.toggle = function (token, force) {
                        if (1 in arguments && !this.contains(token) === !force) {
                            return force;
                        } else {
                            return _toggle.call(this, token);
                        }
                    };

                }

                testElement = null;
            }());
        }
    }

    var classNames = [];
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-ios');
    if (navigator.userAgent.match(/android/i)) classNames.push('device-android');

    var html = document.getElementsByTagName('html')[0];

    if (classNames.length) classNames.push('on-device');
    if (html.classList) html.classList.add.apply(html.classList, classNames);

    /* AJAX SETUP */
    var csrftoken = $.cookie('csrftoken');

    function csrfSafeMethod(method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

    function sameOrigin(url) {
        // test that a given url is a same-origin URL
        // url could be relative or scheme relative or absolute
        var host = document.location.host; // host + port
        var protocol = document.location.protocol;
        var sr_origin = '//' + host;
        var origin = protocol + sr_origin;
        // Allow absolute or scheme relative URLs to same origin
        return (url == origin || url.slice(0, origin.length + 1) == origin + '/') ||
            (url == sr_origin || url.slice(0, sr_origin.length + 1) == sr_origin + '/') ||
            // or any other URL that isn't scheme relative or absolute i.e relative.
            !(/^(\/\/|http:|https:).*/.test(url));
    }

    $.ajaxSetup({

        beforeSend: function (xhr, settings) {
            if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
                // Send the token to same-origin, relative URLs only.
                // Send the token only if the method warrants CSRF protection
                // Using the CSRFToken value acquired earlier
                xhr.setRequestHeader('X-CSRFToken', csrftoken);
            }
        }
    });
    /* END AJAX SETUP */

    /*click outside*/
    (function (jQuery) {
        jQuery.fn.clickoutside = function (callback) {
            var outside = 1, self = $(this);
            self.cb = callback;
            this.click(function () {
                outside = 0;
            });
            $(document).click(function () {
                outside && self.cb();
                outside = 1;
            });
            return $(this);
        }
    })(jQuery);
    /*end click outside*/

    function selectionInjection() {
        $('.article__content').on('copy', function (e) {

            var selectedText = window.getSelection();
            var copyAddedText = '<br /><br /> Pročitajte više na: ' +
                `<a href='${document.location.href}'>${document.location.href}</a> - ${document.location.hostname}`;

            var selectionHelper = $('<div>', { style: { position: 'absolute', left: '-99999px' }, html: selectedText + copyAddedText });
            $('body').append(selectionHelper);

            selectedText.selectAllChildren(selectionHelper[0]);

            window.setTimeout(function () {
                selectionHelper.remove();
            }, 0);
        });
    }

    function initSticky() {
        // Guard in case Stickyfill script fails to load.
        if (typeof Stickyfill === 'undefined') {
            console.warn('[sticky] Stickyfill is not found, thus, not initializing sticky elements.');
            return;
        }
        var $sticky = $('.sticky');
        if ($sticky.length > 0) {
            try {
                $sticky.Stickyfill();
                $sticky.addClass('js_initStickyFN');
            } catch (e) {
                // Silent fail to avoid breaking rest of initialization.
                console.warn('[sticky] initialization failed', e);
            }
        }
        setTimeout(function () {
            if (typeof Stickyfill !== 'undefined' && Stickyfill.rebuild) {
                Stickyfill.rebuild();
            }
        }, 1500);
    }

    function initNano() {

        $('.nano').nanoScroller({
            'preventPageScrolling': true,
            'iOSNativeScrolling': true,
        });
    }

    function initOnLoad() {

        $('.js_initOnLoad').removeClass('hidden');

    }

    function expandToolDescription() {

        var $tool = $('.js_tool');

        if ($tool.length) {

            var $expandBtn = $tool.find('.js_showFullDescription'),
                $toolDescription = $tool.find('.js_toggleDescription');

            $expandBtn.on('click', function (event) {

                event.preventDefault();
                $toolDescription.toggleClass('is_hidden');

            });
        }
    }

    function initIframeResize() {
        $('.js_iframeResizer').find('iframe').iFrameResize();
        $('iframe[id^="_tes"]').iFrameResize();
    }

    setTimeout(function () {
        initIframeResize();
    }, 800);

    function autostartLineClamp() {

        $('.js_card_title').dotdotdot({
            ellipsis: '...',
            height: 'watch',
            tolerance: 0,
            truncate: 'letter',
            watch: 'window'
        });
    }

    initOnLoad();
    selectionInjection();
    initSticky();
    initNano();
    expandToolDescription();
    autostartLineClamp();
});
